import { render, staticRenderFns } from "./post_comment.vue?vue&type=template&id=405134a0"
import script from "./post_comment.vue?vue&type=script&lang=js"
export * from "./post_comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports